import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "credit_app_token";
const USER_KEY = "credit_app_user";
const SYSTEM_UNLOCKED_KEY = "credit_app_system_unlocked";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
};

// System unlock (Step 1) — sessionStorage = caches per browser tab/session.
// Cleared automatically when the tab/window closes (hard refresh).
export const isSystemUnlocked = () => {
    try {
        return sessionStorage.getItem(SYSTEM_UNLOCKED_KEY) === "1";
    } catch {
        return false;
    }
};
export const setSystemUnlocked = () => {
    try {
        sessionStorage.setItem(SYSTEM_UNLOCKED_KEY, "1");
    } catch {
        // ignore
    }
};
export const clearSystemUnlock = () => {
    try {
        sessionStorage.removeItem(SYSTEM_UNLOCKED_KEY);
    } catch {
        // ignore
    }
};

export const getStoredUser = () => {
    try {
        const raw = localStorage.getItem(USER_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};
export const setStoredUser = (u) => {
    if (u) localStorage.setItem(USER_KEY, JSON.stringify(u));
    else localStorage.removeItem(USER_KEY);
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            clearToken();
            if (window.location.pathname !== "/login") {
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    }
);

export const fmtEUR = (n) =>
    new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
    }).format(Number(n) || 0);

export const fmtDate = (iso) => {
    try {
        const d = new Date(iso);
        return d.toLocaleString("el-GR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return String(iso);
    }
};

export const MONTHLY_LIMIT = 25;

/**
 * Returns the `mode` query param for `/customers/search/{q}` based on the input.
 *
 * Rule (per requirement):
 *  - exactly 4 digits → "code" (search ONLY in customer code field)
 *  - >4 digits        → "afm"  (search ONLY in AFM field)
 *  - anything else (non-digit, scanner barcode/QR) → undefined (smart fallback)
 */
export const customerSearchMode = (q) => {
    const s = String(q || "").trim();
    if (!s) return undefined;
    if (!/^\d+$/.test(s)) return undefined; // structured/scanner input → smart
    if (s.length === 4) return "code";
    if (s.length > 4) return "afm";
    return undefined; // 1–3 digits: smart fallback
};
